import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import * as R from 'ramda'
import { useDebounce } from 'rooks'
import { SearchFilter } from '@modules/reception/common/filters/search-filter'
import { SubmitFilter } from '@modules/reception/common/filters/submit-filter'
import { Row } from 'reactstrap'
import { HousekeepingCleaningOrdersOrderedFiltersParams } from './use-housekeeping-cleaning-ordered-orders'
import { HousekeepingCleaningOrderBaseFilters } from '@modules/housekeeping/cleaning-orders/common/improvements-filters'
import { OrderTableViewSwitch, TableViewType } from '@modules/technical-orders/common/table-view-switch'

interface Props {
  filters: HousekeepingCleaningOrdersOrderedFiltersParams
  setFilters: (filters: HousekeepingCleaningOrdersOrderedFiltersParams) => void
  defaultFilters: HousekeepingCleaningOrdersOrderedFiltersParams
  children?: React.ReactNode
  ordersLength: number
  onTableViewChange: (type: TableViewType) => void
  tableView: TableViewType
  isHighPriority?: boolean
}

export const HousekeepingCleaningOrdersOrderedFilters: React.FC<Props> = ({
  filters,
  setFilters,
  defaultFilters,
  children,
  ordersLength,
  tableView,
  onTableViewChange,
  isHighPriority,
}) => {
  const methods = useFormContext<HousekeepingCleaningOrdersOrderedFiltersParams>()

  const values = methods.watch()

  const onSubmitDebounced = useDebounce(values => setFilters(values), 250)

  React.useEffect(() => {
    if (!R.equals(values, filters)) {
      onSubmitDebounced(values)
    }
  }, [values])

  const handleReset = () => {
    methods.reset()
    setFilters(defaultFilters)
  }

  return (
    <Row className="justify-content-end  ml-0">
      {!!ordersLength && (
        <>
          <HousekeepingCleaningOrderBaseFilters id={isHighPriority ? 'high_priority' : 'normal_priority'} />
          <div className="d-flex ml-auto">
            <OrderTableViewSwitch setTableView={onTableViewChange} tableView={tableView} />
            <SubmitFilter hideLabel handleReset={handleReset} formGroupClassName="mb-0" />
            <SearchFilter hideLabel setValue={methods.setValue} colClassName="col-auto" formGroupClassName="mb-0" />
          </div>
        </>
      )}
      {children}
    </Row>
  )
}
